import Table from "components/Table/Table";
import { commonColumnProps, OFFSET, PAGE_SIZE } from "constants/TableConstants";
import { useEffect, useState } from "react";
import type { CellClickArgs } from "react-data-grid";
import { useLocation, useNavigate } from "react-router-dom";
import { setIsLoading } from "reducers/main";
import { useGetEmployersQuery } from "services/employer-api";
import type { EmployerType } from "types/DataTypes";
import { useQuery } from "utils/hooks";
import { useDispatch } from "utils/redux";
import { GLOBAL_SEARCH_PARAM } from "utils/useUrlStore";

import EmployerPageContainer from "./EmployerPageContainer";

const EMPLOYER_COLUMNS = [
  { key: "name", name: "Name", ...commonColumnProps },
  { key: "address", name: "Address", ...commonColumnProps },
  { key: "state", name: "State", ...commonColumnProps },
  {
    key: "zipcode",
    name: "Zipcode",
    render: (value: string | null) => value || "-",
    ...commonColumnProps,
  },
];

const EmployerTable = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const query = useQuery();
  const [page, setPage] = useState(1);

  const { data: employers = { results: [], count: 0 }, isLoading } =
    useGetEmployersQuery(
      {
        searchTerm: query.get(GLOBAL_SEARCH_PARAM),
        limit: PAGE_SIZE,
        offset: OFFSET(page),
      },
      { skip: false },
    );

  const handleCellClick = (args: CellClickArgs<EmployerType, unknown>) => {
    navigate(`${location.pathname}/${args.row.id}/overview`);
  };

  useEffect(() => {
    dispatch(setIsLoading(isLoading));
  }, [dispatch, isLoading]);

  return (
    <EmployerPageContainer>
      <Table
        className="clients-table"
        columns={EMPLOYER_COLUMNS}
        rows={employers.results}
        rowKeyGetter={(row: EmployerType) => row.id}
        onCellClick={handleCellClick}
        isLoading={isLoading}
        fullHeight
        pagination={{
          pageSize: PAGE_SIZE,
          pageIndex: page,
          rowCount: employers.count,
          onPageChange: setPage,
          isLoading,
        }}
      />
    </EmployerPageContainer>
  );
};

export default EmployerTable;
